export const table_titles = [
	{ name: "#", size: 5, order: "" },
	{ name: "Nombre", size: 20, order: "name" },
	{ name: "Paso 1", size: 15, order: "specie_name" },
	{ name: "Paso 2", size: 15, order: "variety_name" },
	{ name: "Cliente", size: 10, order: "customer_name", only_admin: true },
	{ name: "Acción", size: 10, order: "" },
];

export const base_quarter = {
	customer_id: "",
	customer_name: "",
	id: "",
	name: "",
	plantation_distance_end: "",
	plantation_distance: "",
	rootstock: "",
	type_irrigation: "",
	conduction_system: "",
	year: "",
	area: "",
	category_id: "",
	variety_id: "",
	specie_id: "",
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};

export const filters = {
	filter_customer: "",
	filter_estate: "",
	filter_category: "",
	filter_specie: "",
	filter_variety: "",
};
